export default __webpack_public_path__ + "static/media/sample1_v2.33b68898.png";